import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-question-buttons',
  templateUrl: './question-buttons.component.html',
  styleUrls: ['./question-buttons.component.scss']
})
export class QuestionButtonsComponent implements OnInit {

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) {
    if(dataSvc != null && dataSvc !== undefined){
      var usersLanguage = dataSvc.currentUser.Language.DotNetCulture.toString().substring(0,2);
      if(usersLanguage != null){
        translate.setDefaultLang(usersLanguage);
        translate.use(usersLanguage);
      }
      else{
        translate.setDefaultLang('en');
        translate.use('en');
      }
    }
    else{
      translate.setDefaultLang('en');
      translate.use('en');
    }    
   }

  ngOnInit() {
  }

  
}